/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const FoterContainer = styled.div`
  display: flex;
  padding: 16px 24px;
`;
export const ArrowWrap = styled.div`
  display: flex;
  align-items: center;
  margin: 0 8px;
  svg {
    fill: ${Palette.PrimaryGray._400};
  }
`;
